<template>
  <div>
    <base-confirm
      v-if="visible"
      @close="$emit('close')"
      @confirmed="onConfirmed"
      size="max-w-xl"
      message="Isi pesan deskripsi alasan acc atasan"
      type="success"
      icon-type="badge"
      title="ACC Atasan"
      confirm-text="Ya"
      cancel-text="Tutup"
      visible
    >
      <template #content>
        <base-input inset label="Alasan acc atasan" placeholder="Alasan acc atasan" tag="textarea" rows="4" v-model="reason" />
      </template>
    </base-confirm>
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  components: { BaseConfirm },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    orderId: String,
  },
  emits: ['close', 'confirmed'],
  data() {
    return {
      loading: false,
      reason: null
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onConfirmed() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/orders/${this.orderId}/-actions/acc-payment`,
        {
          method: 'patch',
          data: {
            acc_payment_reason: this.reason,
          }
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.$emit('confirmed');
      }

      this.loading = false;
    },
  },
};
</script>
